<template>
  <!-- <div class="banner" v-if="allList && allList.length" :class="allList.length < 4 ? 'banner4' : ''">
    <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" v-if="isPc" id="swiper">
      <swiper-slide v-for="(item, index) in allList" :key="index">
        <img :src="item.bannerImg" alt="" @click="bannerTurn(item)">
      </swiper-slide>
    </swiper>
    <template v-else>
      <div class="item wap" v-for="(item, index) in allList" :key="index">
        <img :src="item.bannerImg" alt="" @click="bannerTurn(item)">
      </div>
    </template>
  </div> -->
  
  <div class="banner wow fadeInDown" v-if="allList && allList.length">
    <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" id="swiper">
      <swiper-slide v-for="(item, index) in allList" :key="index">
        <img :src="item.bannerImg" alt="" @click="link(item, index)">
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  name: 'banner',
  data() {
    return {
      allList: [],
      swiperOptions: {
        loop: true,
        autoplay: 3000,
        autoplayDisableOnInteraction : false,
        // 播放的速度
        speed: 1000,
        //分页器设置
        pagination: {
          el: ".swiper-pagination7",
          clickable: true,
        },
      },
    }
  },
  created() {
    if (this.data && this.data.length) {
      this.allList = this.data
    } else {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.allList = this.data
      // 获取banner底部
      protal.queryAdvertByCode(this.code).then((res) => {
        if (res && res.data && res.data.length) {
          this.allList = res.data;
        }
      });
    },
    openUrl(item) {
        if (item.linkType) { // 链接类型：0 企业详情 1 外部链接 ,
            window.open(item.linkUrl, '_blank')
        } else {
            this.countdown = 0
            this.route({ name: 'videodetail', query: { uuid: item.linkUrl } })
        }
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .banner {
    position: relative;
    width: 100%;
    height: 1.76rem;
    // background: url("https://static.worldaic.com.cn/2024/web/static/images/banner-bg.jpg");
    background-size: cover;
    padding: .54rem 1.1rem 0;

    img {
      border-radius: .16rem;
      cursor: pointer;
      width: 100%;
      height: 1.76rem;
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .banner {
    position: relative;
    width: 100%;
    // background: url("https://static.worldaic.com.cn/2024/web/static/images/banner-bg-wap.jpg");
    background-size: 100% 100%;
    padding: 0 .4rem .5rem;

    img {
      border-radius: .16rem;
      cursor: pointer;
      width: 100%;
      height: .71rem;
    }
  }
    
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue